angular.module('picmonicng').directive('picmonicOptions', [
  function () {
    return {
      restrict: 'E',
      replace: true,
      templateUrl: '/templates/directives/picmonic-options.html',
      scope: {
        card: '=',
        track: '=',
        trackId: '=',
        pathway: '=',
        sharing: '=',
        sharingTitle: '=',
        buttonText: '=',
        location: '@',
        hideExplore: '=',
        fromPlaylist: '=',
        playlistPicmonics: '=',
        sortMethod: '=',
        browsePathwayId: '=',
      },
      controller: [
        '$scope',
        '$state',
        '$timeout',
        'Tracks',
        'PlaylistService',
        'UserService',
        '$modal',
        '$stateParams',
        'MarketOptionsConfig',
        '$rootScope',
        '$location',
        'MetaService',
        'Pathways',
        'toaster',
        '$filter',
        'PicmonicQueue',
        'BrowseService',
        'PrintAndGoService',
        'Playlists',
        'User',
        'PermissionsService',
        function (
          $scope,
          $state,
          $timeout,
          Tracks,
          PlaylistService,
          UserService,
          $modal,
          $stateParams,
          MarketOptionsConfig,
          $rootScope,
          $location,
          MetaService,
          Pathways,
          toaster,
          $filter,
          PicmonicQueue,
          BrowseService,
          PrintAndGoService,
          Playlists,
          User,
          PermissionsService
        ) {
          $scope.canCopy = true;
          $scope.open = false;
          $scope.UserService = UserService;
          $scope.PlaylistService = PlaylistService;
          $scope.PicmonicQueue = PicmonicQueue;
          $scope.PermissionsService = PermissionsService;

          $scope.print = function (layout) {
            if ($scope.card) {
              PrintAndGoService.print('card', $scope.card.card_id, layout);
            } else {
              PrintAndGoService.print('track', $scope.track.track_id, layout);
            }
          };

          $scope.openMenu = function ($event) {
            UserService.see('more_menu');
            $event.stopPropagation();
            $event.preventDefault();
            $scope.addClickToClose();
            $scope.open = true;
          };

          $scope.openSubMenu = function (menu) {
            if (menu == 'add-to-playlist' && typeof PlaylistService.playlists.$promise == 'undefined') {
              PlaylistService.init();
            }

            $scope.activeMenu = menu;
          };

          $scope.closeSubMenu = function () {
            delete $scope.activeMenu;
          };

          $scope.goToPicmonicEvent = function () {};

          $scope.addToPlaylist = function (playlist) {
            if (!$scope.loading) {
              $scope.loading = true;

              if ($scope.card) {
                PlaylistService.addCard($scope.card.card_id, playlist, function () {
                  $scope.loading = false;
                  $scope.closeMenu();
                });
              } else if ($scope.track) {
                PlaylistService.addTrack($scope.track.track_id, playlist, function () {
                  $scope.loading = false;
                  $scope.closeMenu();
                });
              } else if ($scope.pathway) {
                PlaylistService.addPathway($scope.pathway.pathway_id, playlist, function () {
                  $scope.loading = false;
                  $scope.closeMenu();
                });
              }
            }
          };

          $scope.goToSpacedRep = function () {
            if ($scope.card) {
              $state.go('app.quiz', {
                card_id: $scope.card.card_id,
                track_id: null,
                pathway_id: null,
                playlist_id: null,
                quiz_type: 'spacedrep',
                resource_id: 'today',
              });
            } else if ($scope.track) {
              $state.go('app.quiz', {
                card_id: null,
                track_id: $scope.track.track_id,
                pathway_id: null,
                playlist_id: null,
                quiz_type: 'spacedrep',
                resource_id: 'today',
              });
            } else if ($scope.pathway) {
              $state.go('app.quiz', {
                card_id: null,
                track_id: null,
                pathway_id: $scope.pathway.pathway_id,
                playlist_id: null,
                quiz_type: 'spacedrep',
                resource_id: 'today',
              });
            }
          };

          $scope.startSpacedRep = function () {
            $scope.closeMenu();

            var resourceName;
            var parentScope = $scope;

            if ($scope.card) {
              resourceName = $scope.card.name;
            } else if ($scope.track) {
              resourceName = $scope.track.name;
            } else if ($scope.pathway) {
              resourceName = $scope.pathway.name;
            }

            if (!UserService.user.has_seen.spaced_rep_filter) {
              $modal.open({
                templateUrl: '/templates/modals/quiz-spacedrep.html',
                windowClass: 'pls-modal-spaced-rep',
                size: 'md',
                backdropClass: 'above-nav',
                controller: [
                  '$scope',
                  function ($scope) {
                    $scope.resourceName = resourceName;

                    $scope.startSpacedRep = function () {
                      if ($scope.hideModal) {
                        UserService.see('spaced_rep_filter');
                      }

                      parentScope.goToSpacedRep();
                    };
                  },
                ],
              });
            } else {
              $scope.goToSpacedRep();
            }
          };

          $scope.removeFromPlaylist = function (playlist) {
            if (!$scope.loading) {
              $scope.loading = true;
              if ($scope.card) {
                PlaylistService.removeCard($scope.card.card_id, playlist, function () {
                  $scope.loading = false;
                  $scope.closeMenu();
                });
              } else {
                $scope.closeMenu();
              }
            }
          };

          $scope.moveToTopOfPlaylist = function (playlist) {
            if (!$scope.loading) {
              $scope.loading = true;
              if ($scope.card) {
                $scope.playlistPicmonics.splice($scope.playlistPicmonics.indexOf($scope.card), 1);
                $scope.playlistPicmonics.unshift($scope.card);
                $scope.closeMenu();
                PlaylistService.moveCard($scope.card, 0, playlist, function () {
                  $scope.loading = false;
                });
              } else {
                $scope.closeMenu();
              }
            }
          };

          $scope.moveToBottomOfPlaylist = function (playlist) {
            var highestSortOrder = 0;

            var cards = JSON.parse(playlist.cards);

            angular.forEach(cards, function (card) {
              if (card.sort_order > highestSortOrder) {
                highestSortOrder = card.sort_order;
              }
            });

            if (!$scope.loading) {
              $scope.loading = true;
              if ($scope.card) {
                $scope.playlistPicmonics.splice($scope.playlistPicmonics.indexOf($scope.card), 1);
                $scope.playlistPicmonics.push($scope.card);
                $scope.closeMenu();
                PlaylistService.moveCard($scope.card, highestSortOrder + 1, playlist, function () {
                  $scope.loading = false;
                });
              } else {
                $scope.closeMenu();
              }
            }
          };

          $scope.addToNewPlaylist = function () {
            $scope.closeMenu();
            PlaylistService.create().then(function (playlist) {
              $scope.addToPlaylist(playlist);
            });
          };

          $scope.delete = function (card) {
            var close = $scope.closeMenu;
            $modal.open({
              templateUrl: '/templates/modals/delete-confirm.html',
              size: 'md',
              controller: [
                '$scope',
                'Picmonics',
                function ($scope, Picmonics) {
                  $scope.confirmation_text = 'Are you sure you want to delete this picmonic?';
                  $scope.loading = false;

                  $scope.confirm = function () {
                    $scope.loading = true;
                    Picmonics.delete({ card_id: card.card_id }, function () {
                      $rootScope.$broadcast('myCardDataChanged');
                      $scope.$close();
                      close();
                    });
                  };

                  $scope.cancel = function () {
                    $scope.$dismiss();
                  };
                },
              ],
            });
          };

          $scope.closeMenu = function () {
            $scope.removeClickToClose();
            $scope.open = false;
            $scope.closeSubMenu();

            $timeout(function () {
              $scope.$apply();
            });
          };

          $scope.getShareUrl = function () {
            var url = window.location.href;
            if ($scope.card) {
              url = $location.protocol() + '://' + $location.host() + '/share/picmonic/' + $scope.card.slug;
            } else if ($scope.track) {
              url =
                $location.protocol() +
                '://' +
                $location.host() +
                '/share/track/' +
                $filter('slugify')($scope.track.name) +
                '_' +
                $scope.track.track_id;
            } else if ($scope.pathway) {
              url =
                $location.protocol() +
                '://' +
                $location.host() +
                '/share/pathway/' +
                $filter('slugify')($scope.pathway.name) +
                '_' +
                $scope.pathway.pathway_id;
            }
            return url;
          };

          var shareURL = $scope.getShareUrl();
          $scope.copyUrl = shareURL + (shareURL.indexOf('?') !== -1 ? '&' : '?') + UserService.getReferralParam();

          $scope.copyError = function () {
            $scope.canCopy = false;
          };

          // Navigate to the provided pathway
          $scope.goToPathway = function (pathway) {
            if (pathway.track_id && $scope.pathway && $scope.pathway.pathway_id) {
              BrowseService.go('app.pathways.market.' + $scope.pathway.pathway_type + '.tracks.picmonics', {
                pathway_id: $scope.pathway.pathway_id,
                track_id: pathway.track_id,
              });
            } else {
              BrowseService.go(
                'app.pathways.market.' + pathway.pathway_type + '.tracks' + (pathway.track_id ? '.picmonics' : ''),
                {
                  curriculum: pathway.curriculum,
                  market: MarketOptionsConfig.getMarketById(pathway.market_id).slug,
                  pathway_id: $scope.browsePathwayId || pathway.pathway_id,
                  track_id: pathway.track_id,
                  scroll_to: pathway.tertiary_pathway_id || pathway.sub_pathway_id || pathway.secondary_pathway_id,
                }
              );
            }
          };

          $scope.archivePathway = function (pathway) {
            User.update_pathway({ pathway_id: pathway.pathway_id }, { is_archived: 1 });
            pathway.hidden = 1;
            $scope.closeMenu();
          };

          $scope.share = function (method, failed) {
            var target = 'Pathway';
            var title = '';
            var url = $scope.getShareUrl();

            if (method !== 'copy') {
              if ($scope.card) {
                $scope.showSharingWidget(method, target, url, title);
              } else if ($scope.track) {
                $scope.showSharingWidget(method, target, url, $scope.track.name);
              } else if ($scope.pathway) {
                $scope.showSharingWidget(
                  method,
                  target,
                  url,
                  $scope.sharingTitle ? $scope.sharingTitle : $scope.pathway.name
                );
              }
            }

            if (method == 'copy') {
              if (failed == true) {
                var copyUrl = $scope.copyUrl;
                // Pop modal
                $modal.open({
                  templateUrl: '/templates/modals/share-copy.html',
                  windowClass: 'above-nav learn-light-modal',
                  backdropClass: 'above-nav',
                  backdrop: 'static',
                  keyboard: false,
                  size: 'md',
                  controller: [
                    '$scope',
                    '$modalInstance',
                    '$timeout',
                    function ($scope, $modalInstance, $timeout) {
                      $timeout(function () {
                        var input = $('#copy-modal-url');
                        input.focus();
                        input.select();
                      }, 0);

                      $scope.close = function () {
                        $modalInstance.close();
                      };

                      $scope.picmonic_url = copyUrl || !is_numeric($market_id);
                    },
                  ],
                });
              } else {
                toaster.success('Copied', 'URL has been copied to the clipboard.');
              }
            }

            $scope.closeSubMenu();
            $scope.closeMenu();
          };

          $scope.showSharingWidget = function (method, target, url, title) {
            send_ga('event', target, 'Shared on: ' + method);

            // Prepare UTM sharing variables
            var shareSource;
            if ($scope.card) {
              shareTermTwitter = '1464893340';
              shareTermFacebook = '1464893298';
            } else {
              shareTermTwitter = '1461766380';
              shareTermFacebook = '1461765952';
            }
            shareSource = $scope.card ? 'picmonic' : 'pathway';

            switch (method) {
              case 'twitter':
                var left =
                  window.outerWidth / 2 - 300 + (window.screenLeft != undefined ? window.screenLeft : screen.left);
                var top =
                  window.outerHeight / 2 - 200 + (window.screenTop != undefined ? window.screenTop : screen.top);
                url = encodeURIComponent(
                  url +
                    (url.indexOf('?') !== -1 ? '&' : '?') +
                    'utm_source=twitter&utm_medium=social&utm_term=' +
                    shareTermTwitter +
                    '&utm_content=image_link&utm_campaign=' +
                    shareSource +
                    '_share_tw&' +
                    UserService.getReferralParam()
                );

                title = 'Learn ' + title + ' with Picmonic!';

                window.open(
                  'https://twitter.com/share?url=' + url + '&text=' + title,
                  'twitter',
                  'height=400,width=600,left=' +
                    left +
                    ',top=' +
                    top +
                    ',location=no,resizable=no,scrollbars=no,status=no,toolbar=no,titlebar=no'
                );
                break;
              case 'facebook':
                FB.ui({
                  method: 'share',
                  display: 'popup',
                  href:
                    url +
                    (url.indexOf('?') !== -1 ? '&' : '?') +
                    'utm_source=facebook&utm_medium=social&utm_term=' +
                    shareTermFacebook +
                    '&utm_content=image_link&utm_campaign=' +
                    shareSource +
                    '_share_fb&' +
                    UserService.getReferralParam(),
                });
                break;
            }
          };

          $scope.downloadLiveSlide = function () {
            var url =
              'https://api.liveslides.com/v1/slide?title=Picmonic&url=https%3A%2F%2Fwww.picmonic.com%2Flearn%2F' +
              $scope.card.slug;
            if (!UserService.seen('liveslides')) {
              var modal = $modal.open({
                templateUrl: '/templates/modals/liveslides.html',
                windowClass: 'above-nav learn-light-modal',
                backdropClass: 'above-nav',
                backdrop: 'static',
                keyboard: true,
                size: 'sm',
              });
              modal.result.then(function () {
                atlasEvent('click', 'liveslides');
                UserService.see('liveslides');
                window.open(url);
              });
            } else {
              atlasEvent('click', 'liveslides');
              window.open(url);
            }
          };
        },
      ],
      link: function (scope, element, attrs) {
        if (scope.buttonText) {
          element.addClass('card-options--text');
        }
        function clickHandler(e) {
          if (
            scope.open === true &&
            element[0] != e.target &&
            !angular.element(element).has(angular.element(e.target)).length
          ) {
            scope.$apply(function () {
              scope.closeMenu();
            });
          }
        }

        element.on('mouseout', function (e) {
          window.setTimeout(function () {
            if (element.find('.zeroclipboard-is-hover').length) {
              element.closest('.pathway-tile__content').addClass('copy-hover');
            } else {
              element.closest('.pathway-tile__content').removeClass('copy-hover');
            }
          }, 0);
        });

        element.on('focusout', function (e) {
          if (e.relatedTarget && e.relatedTarget.nodeName != 'LI' && e.relatedTarget != e.currentTarget) {
            scope.$apply(function () {
              scope.closeMenu();
            });
          }
        });

        // On escape keypress, close menu
        element.on('keydown', function (e) {
          if (scope.open && e.keyCode == 27) {
            scope.$apply(function () {
              scope.closeMenu();
            });
          }
        });

        scope.addClickToClose = function () {
          document.body.addEventListener('click', clickHandler, true);
        };

        scope.removeClickToClose = function () {
          document.body.removeEventListener('click', clickHandler, true);
        };
      },
    };
  },
]);
